import React, { useContext } from "react";
import StudyProgress from "../StudyProgress";
import StudyBtn from "../../../StudyBtn";
import Spacer from "components/Spacer";
import styles from "./index.module.scss";
import { ChapterContext } from "../../../../../../store";

interface ChapterHeader {
    title: string;
    percent: number; // 30% 就写30
}

export default function ChapterHeader({ title, percent }: ChapterHeader) {
    const { onContinue, todoResource } = useContext(ChapterContext);

    return (
        <div className={styles.root}>
            <div className={styles.title}>{title}</div>
            <Spacer />
            <StudyProgress percent={percent} />
            {todoResource && <StudyBtn onClick={onContinue} />}
        </div>
    );
}
